export default __webpack_public_path__ + "static/media/rank_1.e0d1fe05.svg";